import { GraphQLObjectType, GraphQLString, GraphQLInt } from 'graphql';
import UserType from './user.gql';
import CourseType from './course.gql';

const feedbackType = new GraphQLObjectType({
  name: 'Feedback',
  fields: () => ({
    userId: {
      type: GraphQLString,
      resolve: item => item.userId
    },
    user: {
      type: UserType,
      resolve: item => item.user
    },
    course: {
      type: CourseType,
      resolve: item => item.course
    },
    courseId: {
      type: GraphQLString,
      resolve: item => item.courseId
    },
    starsGiven: {
      type: GraphQLInt,
      resolve: item => item.starsGiven
    },
    totalStars: {
      type: GraphQLInt,
      resolve: item => item.totalStars
    },
    feedbackText: {
      type: GraphQLString,
      resolve: item => item.feedbackText
    }
  })
});

window[feedbackType.name + 'GQLType'] = feedbackType;

export default feedbackType;
